module.exports = __webpack_public_path__ + "68d0ec6619e70208ae1348a48026173f.png";